import { useApp } from "@/contexts/AppContext";
import { Database, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Topbar({ title, subtitle, actions }) {
  const { isSample, fileName, activeRows } = useApp();
  const navigate = useNavigate();

  return (
    <div className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 sticky top-0 z-20">
      <div className="min-w-0">
        <h1 data-testid="page-title" className="font-heading font-semibold text-[20px] tracking-tight text-slate-900 leading-none truncate">
          {title}
        </h1>
        {subtitle ? (
          <p className="text-xs text-slate-500 mt-1.5 truncate">{subtitle}</p>
        ) : null}
      </div>

      <div className="flex items-center gap-3">
        {isSample ? (
          <button
            data-testid="sample-data-banner"
            onClick={() => navigate("/import")}
            className="hidden md:flex items-center gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-md hover:bg-amber-100 transition-colors"
          >
            <Database className="h-3.5 w-3.5" />
            <span>Viewing sample data — upload your file to begin</span>
          </button>
        ) : (
          <div data-testid="active-dataset-banner" className="hidden md:flex items-center gap-2 text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 px-3 py-1.5 rounded-md">
            <FileSpreadsheet className="h-3.5 w-3.5" />
            <span className="font-mono">{fileName}</span>
            <span className="text-emerald-700">· {activeRows.length} rows</span>
          </div>
        )}
        {actions}
        <Button
          data-testid="topbar-import-btn"
          variant="default"
          size="sm"
          className="bg-slate-900 hover:bg-slate-800 text-white"
          onClick={() => navigate("/import")}
        >
          Import Data
        </Button>
      </div>
    </div>
  );
}
